class AsLuckyWheel {
    constructor() {
        this.luckyNode = {
            luckyWheel: '#as-lucy-wheel'
        };
        this.luckyPrize = {};
        this.options = {};
        this.luckyInstance = null;
        this.expiresTimer = null;
        this.initLuckyWheel();
        this.initLuckyWheelEvent();
    }
    clearLuckyStorage() {
        localStorage.removeItem('as_lucky_prize');
        localStorage.removeItem('as_lucky_step');
        localStorage.removeItem('as_lucky_video_play');
    }
    loadImg(src) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = src;
            img.onload = ()=> resolve();
            img.onerror = ()=> resolve();
        });
    }
    loadImgs(imgs = []) {
        return Promise.all(imgs.map((src) => this.loadImg(src)))
    }
    copyTextToClipboard(text) {
        let textArea = document.createElement('textarea');
        textArea.style.position = 'fixed';
        textArea.style.top = '-9999px';
        textArea.style.left = '-9999px';
        textArea.style.zIndex = -9999;
        textArea.value = text;
        textArea.setAttribute('readonly', '');
        document.body.appendChild(textArea)
        textArea.select();
        textArea.setSelectionRange(0, textArea.value.length);
        let flag = false;
        try {
            flag = document.execCommand('copy');
        } catch (err) {}
        return flag;
    }
    createLuckyWheel({ rotaryTableDiagram, prizes = [], offsetDegree = 0 }) {
        // const lucky_size = screenWidth <= 766 ? '310px' : '410px';
        const lucky_size = '310px';
        //以纵轴为基准 所以4和8offsetDegree不用偏移 6需要偏移30
        this.options = {
            width: lucky_size,
            height: lucky_size,
            defaultConfig: {
                offsetDegree,
                speed: 15
            },
            prizes,
            blocks: [{
                imgs: [{
                  src: rotaryTableDiagram,
                  width: lucky_size,
                  height: lucky_size,
                  rotate: true
                }]
            }]
        };
        this.luckyInstance = new LuckyCanvas.LuckyWheel(this.luckyNode.luckyWheel, this.options);
        $(this.luckyNode.luckyWheel).addClass('as-lucy-rotate');
    }
    createLuckyPopup({ bg, collapseStyle, centerLogo, pointerPraph, backgroundImageCountdown, activityName }) {
        $('.as-lucky-popup').after(`
            <img class="as-lucky-mini" loading="lazy" src="${collapseStyle}" />
        `).attr('data-name', activityName);
        // $('.as-lucky-content').css({ backgroundImage: `url(${bg})`});
        // $('.as-lucky-point').css({ backgroundImage: `url(${pointerPraph})`});
        $('.as-lucky-center').css({ backgroundImage: `url(${centerLogo})`});
        // $('.as-lucky-time').css({ backgroundImage: `url(${backgroundImageCountdown})`});
    }
    changeToStep(_step) {
        const step = _step || localStorage.getItem('as_lucky_step') || 'as-lucky-start';
        $('.as-lucky-content').removeClass().addClass(`as-lucky-content ${step}`);
        // loading时不用存储当前步骤的cookie
        if (step.indexOf('as-lucky-loading') > -1) return;
        localStorage.setItem('as_lucky_step', step);
    }
    formatPrize(activityPrizeBOList = []) {
        const prize_num = activityPrizeBOList.length;
        // const w_h_6 = screenWidth <= 766 ? 58 : 100;
        // const top_6 = screenWidth <= 766 ? 17 : 20;
        // const w_h_8 = screenWidth <= 766 ? 48 : 80;
        // const top_8 = screenWidth <= 766 ? 16 : 28;
        const prizes = activityPrizeBOList.map((item) => ({
            background: 'transparent',
            imgs: [{
                src: item.prizeImage,
                // top: prize_num == 6 ? top_6 : top_8,
                // width: prize_num == 6 ? w_h_6 : w_h_8,
                // height: prize_num == 6 ? w_h_6 : w_h_8
                // src: 'https://d1pvf64asr5voy.cloudfront.net/assets/img/08/01/n_1722477784714_4244.png',
                // src: 'https://d1pvf64asr5voy.cloudfront.net/assets/img/08/01/n_1722477878792_8505.png',
                top: 18,
                width: 68,
                height: 72
            }]
        }));
        return { prize_num, prizes };
    }
    initLuckyStep() {
        const as_lucky_prize = localStorage.getItem('as_lucky_prize');
        const as_lucky_step = localStorage.getItem('as_lucky_step');
        if (as_lucky_prize && as_lucky_step && as_lucky_step.indexOf('as-lucky-result') > -1) {
            this.showPrize(JSON.parse(as_lucky_prize));
            return;
        }
        this.changeToStep('as-lucky-start');
        this.clearLuckyStorage();
    }
    initLuckyWheel() {
        AjaxApi('/web/shopify/activity/prize', { channel: 1 }).then(({ entry }) => {
            if (!entry?.id) {
                this.clearLuckyStorage();
                return;
            }
            const { activityId } = JSON.parse((localStorage.getItem('as_lucky_prize') || '{}'));
            // 新活动 清除之前的缓存
            if (activityId != entry.id) { this.clearLuckyStorage(); }
            this.luckyPrize = entry;
            const {
                backgroundImage, // pc 背景图
                backgroundImageH5, //h5背景他
                centerLogo, // 中心图
                backgroundImageCountdown, //倒计时背景图
                collapseStyle, // 缩略图
                pointerPraph, // 箭头
                rotaryTableDiagram, // 大转盘
                activityPrizeBOList,
                effectivePage,
                ejectTime,
                activityName
            } = entry;
            // console.time('imgLoading');
            // this.loadImgs([backgroundImage, backgroundImageH5, rotaryTableDiagram]).then(() => {
                // console.timeEnd('imgLoading');
                // this.loadImgs([backgroundImage, backgroundImageH5, rotaryTableDiagram]);
                this.loadImgs([rotaryTableDiagram, centerLogo, collapseStyle]);
                if (!effectivePage) return;
                const scenes = effectivePage.split(',');
                let shopify_scene = theme.template_name;
                if (shopify_scene == 'index') { shopify_scene = 'home' };
                if (shopify_scene == 'product') { shopify_scene = 'detail' };
                if (!scenes.includes(shopify_scene)) return;
                // as_lucky_open_popup 大转盘一天自动弹出一次
                const as_lucky_open_popup = $.cookie('as_lucky_open_popup');
                const { prize_num, prizes } = this.formatPrize(activityPrizeBOList);
                // const offsetDegree = prize_num == 6 ? 30 : 0;
                const offsetDegree = 0;
                this.createLuckyWheel({
                    rotaryTableDiagram, 
                    prizes,
                    offsetDegree
                });
                // const bg = screenWidth <= 766 ? backgroundImageH5: backgroundImage;
                const bg = backgroundImageH5;
                this.createLuckyPopup({ bg, collapseStyle, centerLogo, pointerPraph, backgroundImageCountdown, activityName });
                this.initLuckyStep();
                // this.loadImgs([backgroundImageCountdown]);
                // 一天一次自动弹出 且 没有输入过邮箱
                const as_lucky_prize = localStorage.getItem('as_lucky_prize') || '{}';
                const { email } = JSON.parse(as_lucky_prize);
                if (!as_lucky_open_popup && !email) {
                    // 指定页面不自动弹出
                    const no_popup = [
                        '/pages/3-movement-short',
                        '/pages/performance-chino-short',
                        '/pages/softest-sunday-performance-tee',
                        '/pages/kore-curved-hem-t-shirt'
                    ];
                    if (no_popup.includes(theme.current_url)) return;
                    setTimeout(() => {
                        $('.as-lucky-mini').trigger('click');
                        $.cookie(`as_lucky_open_popup`, true, { expires: 1, path: '/' });
                    }, ejectTime * 1000);
                }
            // })
        });
    }
    emailError(text) {
        let timer;
        clearTimeout(timer);
        const luck_form = $('.as-lucky-form');
        $('.as-lucky-form-error').remove();
        luck_form.append(`<div class="as-lucky-form-error">${text}</div>`);
        timer = setTimeout(function() {
            $('.as-lucky-form-error').remove();
        }, 3000);
    }
    timeDown({ time = 5, callback }) {
        let timerInterval = setInterval(function () {
            if (time <= 1) {
                clearInterval(timerInterval);
                timerInterval = null;
                callback();
                return;
            }
            time -= 1;
            $('.as-lucky-time').text(time);
        }, 1000);
        $('.as-lucky-time').text(time);
    }
    animationWheel({ prize, time = 5 }) {
        this.luckyInstance.play();
        const { activityPrizeBOList = [] } = this.luckyPrize;
        const prize_index = activityPrizeBOList.findIndex((list) => list.id == prize.prizeId);
        setTimeout(() => {
            // as-lucy-success pc需要偏转90才能使奖品对应箭头 移动端需要偏转180
            // $(this.luckyNode.luckyWheel).removeClass('as-lucy-rotate').addClass('as-lucy-success');
            $(this.luckyNode.luckyWheel).removeClass('as-lucy-rotate');
            this.luckyInstance.stop(prize_index);
        }, time * 1000 - 2500);
    }

    countExpireTime({ effectiveTime, startWinTime }) {
        clearInterval(this.expiresTimer);
        this.expiresTimer = setInterval(function () {
            const time = Math.floor((effectiveTime - (Date.now() - startWinTime)) / 1000);
            const h = parseInt(time / 3600);
            const m = parseInt((time % 3600) / 60);
            const s = parseInt(time % 60);
            const hs = h > 9 ? h : '0' + h;
            const ms = m > 9 ? m : '0' + m;
            const ss = s > 9 ? s : '0' + s;
            if (time <= 0) {
                clearInterval(this.expiresTimer);
                $('.as-lucky-prize-time').text('');
            } else {
                $('.as-lucky-prize-time').text(`Explres in ${hs}:${ms}:${ss}`)
            }
        }, 1000)
    }
    showPrize(prizeData = {}) {
        const { prizeType, prizeImage, prizeLuckyImage, prizeIndex, prize, effectiveTime, startWinTime } = prizeData;
        $('.as-lucky-prize .as-lucky-prize-img').css({ backgroundImage: `url(${prizeLuckyImage || prizeImage})`});
        prizeType == 3 ? $('.as-lucky-prize-add').data('sku', prize) : $('.as-lucky-prize .code__content').text(prize);
        this.countExpireTime({ effectiveTime, startWinTime });
        const videoPlay = localStorage.getItem('as_lucky_video_play');
        const step = `as-lucky-result as-lucky-result-${prizeType} ${videoPlay ? 'as-lucky-result-try' : ''} ${prizeIndex > 1 ? 'as-lucky-result-again' : ''}`;
        this.changeToStep(step);
    }
    
    clickWheel({ email, prizeIndex = 1 }) {
        $('.as-lucky-loading-btn').addClass('loading');
        const { id } = this.luckyPrize;
        AjaxApi('/web/shopify/active/luckDraw', {
            email,
            activityId: id,
            prizeIndex
        }, 'post').then(({ entry, code, message }) => {
            if (code == 100) {
                this.emailError(message);
                return;
            }
            if (code == 200 && entry) {
                const as_lucky_prize = { ...entry, email, prizeIndex, activityId: id, startWinTime: Date.now() };
                localStorage.setItem('as_lucky_prize', JSON.stringify(as_lucky_prize));
                localStorage.removeItem('as_lucky_video_play');
                this.changeToStep(`as-lucky-content as-lucky-loading`);
                this.animationWheel({ prize: entry });
                this.timeDown({ callback: () => this.showPrize(as_lucky_prize) });
            }
        }).done(() => {
            $('.as-lucky-loading-btn').removeClass('loading');
        });
    }
    initLuckyWheelEvent() {
        const $this = this;
        $(document).on('click', '.as-lucky-close, .as-lucky-prize-shop', function () {
            $('.as-lucky-popup').hide();
            $('html, body').removeClass('skuActive');
        });
        $(document).on('click', '.as-lucky-mini', function () {
            $('.as-lucky-popup').show();
            $('html, body').addClass('skuActive');
        });
        $(document).on("click", '.as-lucky-form-btn', function () {
            const emailReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            const email_val = $('.as-lucky-form-input').val();
            if (!emailReg.test(email_val)) {
                $this.emailError('Invalid Email Address');
                return;
            }
            $this.clickWheel({ email: email_val });
        });
        $(document).on("click", '.code__btn', function () {
            const code_text = $(this).siblings('.code__content').text();
            if ($this.copyTextToClipboard(code_text)) {
                $(this).text('Copied')
            }
        });
        // $(document).on('click', '.as-lucky-prize-again', function() {
        //     // localStorage.setItem('as_lucky_video_play', true);
        //     // // 模拟视频回调
        //     // setTimeout(() => {
        //     //     $('.as-lucky-content').addClass('as-lucky-result-try');
        //     // }, 2000);
        // });
        $(document).on('click', '.as-lucky-prize-try', function() {
            const as_lucky_prize = localStorage.getItem('as_lucky_prize') || '{}';
            const { email } = JSON.parse(as_lucky_prize);
            $this.clickWheel({ email, prizeIndex: 2 });
        });
        $(document).on('click', '.as-lucky-prize-add', function() {
            // const sku = $('.as-lucky-prize-add').data('sku');
            // const { cart: { items = [] } } = CartJS;
            // const luckyWheelGoodsId = (items.find((item) => item.properties && item.properties.luckyWheelGift) || {}).id;
            // // 该赠品已加购
            // if (luckyWheelGoodsId == sku) {
            //     $(".block-cart").addClass("active");
            //     return;
            // }
            //存在赠品 但不是当前添加的需要移除
            // $("body").addClass("loading");
            // if (luckyWheelGoodsId) {
            //     CartJS.removeItemById(luckyWheelGoodsId)
            // }
            // CartJS.addItem(sku, 1, { luckyWheelGift: true }, {
            //     "success": function () {
            //         setTimeout(function() {
            //             $("body").removeClass("loading showOverly");
            //             $(".block-cart").addClass("active");
            //         }, 1000);
            //     }
            // });
        });
    }
}
new AsLuckyWheel();